import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import "./i18n/i18n";
import { syncDocumentLang } from "./i18n/i18n";
import AuthProvider from "./AuthProvider";
import Root from "./nav/Root";

syncDocumentLang(localStorage.getItem("proteinpal_lang") ?? undefined);

const rootElement = document.getElementById("root")!;
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <Root />
    </AuthProvider>
  </React.StrictMode>
);
